<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw==" crossorigin="anonymous" referrerpolicy="no-referrer" />

<div class="employee-management-container">
  <div class="header">
    <h2>Employee Management</h2>
    <div class="controls-container">
      <div class="search-filter">
        <div class="input-group">
          <input 
            type="text" 
            [(ngModel)]="searchTerm" 
            (ngModelChange)="applyFilters()" 
            placeholder="Search employees..." 
            class="form-control search-input" 
            aria-label="Search employees">
          <select 
            [(ngModel)]="selectedDepartment" 
            (ngModelChange)="applyFilters()" 
            class="form-control department-filter" 
            aria-label="Filter by department">
            <option value="">All Departments</option>
            <option *ngFor="let dept of departments" [value]="dept.id" [class.d-none]="dept.status !== 1">
              {{ dept.name }}
            </option>
          </select>
          <button 
            class="btn btn-outline-secondary reset-btn"
            (click)="searchTerm = ''; selectedDepartment = ''; applyFilters()"
            aria-label="Reset filters">
            Reset
          </button>
        </div>
      </div>
      <div class="action-buttons">
        <div class="excel-actions">
          <input type="file" #fileInput class="hidden" (change)="importExcel($event)" accept=".xlsx" aria-label="Import employees from Excel file">
          <button class="btn btn-success" (click)="fileInput.click()" aria-label="Import employees from Excel">
            <i class="fas fa-file-import"></i> Import Excel
          </button>
          <button class="btn btn-info" (click)="exportExcel()" aria-label="Export employees to Excel">
            <i class="fas fa-file-export"></i> Export Excel
          </button>
          <button class="btn btn-primary add-btn" (click)="openAddEmployeeModal()" aria-label="Add new employee">
            <i class="fas fa-plus"></i> Add Employee
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Employee List Table -->
  <div class="card">
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Name</th>
              <th>Position</th>
              <th>Department</th>
              <th>Email</th>
              <th>Hire Date</th>
              <th>Tenure</th>
              <th>Age</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let employee of filteredEmployees$ | async">
              <td>{{ employee.name }}</td>
              <td>{{ employee.position || 'N/A' }}</td>
              <td>{{ getDepartmentName(employee.department) }}</td>
              <td>{{ employee.email }}</td>
              <td>{{ formatDate(employee.hireDate) }}</td>
              <td>{{ calculateTenure(employee.hireDate) }} {{ calculateTenure(employee.hireDate) !== 'N/A' ? 'year(s)' : '' }}</td>
              <td>{{ calculateAge(employee.birthDate) }} {{ calculateAge(employee.birthDate) !== 'N/A' ? 'year(s)' : '' }}</td>
              <td class="actions-column">
                <div class="btn-group">
                  <button class="btn btn-sm btn-outline-primary me-1" (click)="editEmployee(employee)" title="Edit">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-danger" (click)="deleteEmployee(employee.id)" title="Delete">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="(filteredEmployees$ | async)?.length === 0">
              <td colspan="8" class="text-center">No employees found.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Employee Modal -->
  <div *ngIf="showEmployeeModal" class="modal-container">
    <!-- Backdrop - prevent click events from propagating through modal content to backdrop -->
    <div class="modal-backdrop" (click)="closeEmployeeModal()"></div>
    
    <!-- Modal dialog - stop click propagation to prevent backdrop click handler -->
    <div class="modal-dialog modal-lg" role="document" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ editingEmployee ? 'Edit Employee' : 'Add New Employee' }}</h5>
          <button type="button" class="close-btn" (click)="closeEmployeeModal()" aria-label="Close">
            Close
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="employeeForm" (ngSubmit)="saveEmployee()">
            <div class="row">
              <!-- Basic Information -->
              <div class="col-md-6">
                <h6 class="mb-3">Basic Information</h6>
                
                <div class="form-group">
                  <label for="name">Full Name <span class="text-danger">*</span></label>
                  <input 
                    type="text" 
                    id="name" 
                    formControlName="name" 
                    class="form-control" 
                    [ngClass]="{'is-invalid': employeeForm.get('name')?.invalid && employeeForm.get('name')?.touched}"
                  >
                  <div class="invalid-feedback" *ngIf="employeeForm.get('name')?.invalid && employeeForm.get('name')?.touched">
                    Name is required.
                  </div>
                </div>

                <div class="form-group">
                  <label for="email">Email <span class="text-danger">*</span></label>
                  <input 
                    type="email" 
                    id="email" 
                    formControlName="email" 
                    class="form-control"
                    [ngClass]="{'is-invalid': employeeForm.get('email')?.invalid && employeeForm.get('email')?.touched}"
                  >
                  <div class="invalid-feedback" *ngIf="employeeForm.get('email')?.invalid && employeeForm.get('email')?.touched">
                    Valid email is required.
                  </div>
                </div>

                <div class="form-group">
                  <label for="phone">Phone Number</label>
                  <input type="tel" id="phone" formControlName="phone" class="form-control">
                </div>

                <div class="form-group">
                  <label for="birth_date">Birth Date <span class="text-danger">*</span></label>
                  <input 
                    type="date" 
                    id="birth_date" 
                    formControlName="birth_date" 
                    class="form-control"
                    [ngClass]="{'is-invalid': employeeForm.get('birth_date')?.invalid && employeeForm.get('birth_date')?.touched}"
                  >
                  <div class="invalid-feedback" *ngIf="employeeForm.get('birth_date')?.invalid && employeeForm.get('birth_date')?.touched">
                    Birth date is required.
                  </div>
                </div>
              </div>

              <!-- Employment Information -->
              <div class="col-md-6">
                <h6 class="mb-3">Employment Information</h6>
                <!-- Deparments -->
                <div class="form-group">
                  <label for="department">Department</label>
                  <select id="department" formControlName="department" class="form-control">
                    <option value="">Select Department</option>
                    <option *ngFor="let dept of departments" [value]="dept.id" [class.d-none]="dept.status !== 1">
                      {{ dept.name }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="position">Position</label>
                  <input type="text" id="position" formControlName="position" class="form-control">
                </div>

                <div class="form-group">
                  <label for="hire_date">Hire Date <span class="text-danger">*</span></label>
                  <input 
                    type="date" 
                    id="hire_date" 
                    formControlName="hire_date" 
                    class="form-control"
                    [ngClass]="{'is-invalid': employeeForm.get('hire_date')?.invalid && employeeForm.get('hire_date')?.touched}"
                  >
                  <div class="invalid-feedback" *ngIf="employeeForm.get('hire_date')?.invalid && employeeForm.get('hire_date')?.touched">
                    Hire date is required.
                  </div>
                </div>

                <div class="form-group">
                  <label for="workplace">Workplace</label>
                  <input type="text" id="workplace" formControlName="workplace" class="form-control">
                </div>
              </div>
            </div>

            <!-- Skills -->
            <div class="form-group mt-3">
              <label for="skills">Skills & Competencies</label>
              <textarea id="skills" formControlName="skills" class="form-control" rows="3" placeholder="Enter skills separated by commas"></textarea>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeEmployeeModal()">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="saveEmployee()">
            <i class="fas fa-save"></i> {{ editingEmployee ? 'Update' : 'Save' }} Employee
          </button>
        </div>
      </div>
    </div>
  </div>
</div> 